import PropTypes from 'prop-types'

import { PERPETUAL } from '@/constants/durations'
import { translate } from '@/utils/translations'

const SingleVariantOption = ({ duration }) => (
  <p className='u-push-half--ends cart-item-duration'>
    <span className='u-weight--medium'>
      {translate('common.duration')}{': '}
    </span>
    <Choose>
      <When condition={duration === PERPETUAL}>
        {translate('purchase.buy_eTextbook')}
      </When>
      <Otherwise>
        {duration}
      </Otherwise>
    </Choose>
  </p>
)

export default SingleVariantOption

SingleVariantOption.propTypes = {
  duration: PropTypes.string.isRequired
}
